import React, { useState } from 'react'
import { Modal } from '../../../../component/Modal'
import { DuetButtons } from '../../../../component/ActionButtons/DuetButtons'

export const ExportModal: React.FC<{
    isShow: boolean
    onClose: () => void
    onExport: (tag: string, exportPassword?: string) => void
}> = ({ isShow, onClose, onExport }) => {
    const [tag, setTag] = useState('')
    const [exportPassword, setExportPassword] = useState('')
    const onChangeTag = (e: React.ChangeEvent<HTMLInputElement>) => {
        setTag(e.target.value)
    }
    const onChangePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setExportPassword(e.target.value)
    }
    const changed = (visible: boolean) => {
        if (!visible) {
            onClose()
        }
    }
    if (!isShow) {
        return null
    }
    return (
        <div style={{ position: 'fixed', zIndex: 1000,
            top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
            <Modal
                isShow={isShow}
                changed={changed}
            >
                <div style={{ padding: '2px 0 16px 0' }}>
                    <h1>Экспорт продуктов в файл</h1>
                    <p>Введите тег для экспортируемых продуктов. Например, &quot;базовые&quot; или оставить пустым</p>
                    <input name='tag' type="text" value={tag} onChange={onChangeTag} placeholder='тег' />
                    <p style={{ fontSize: 12, color: '#777' }}>
                        это позволит в будущем ориентироваться в ручную добавленных продуктах и в импортированных продуктах.
                    </p>
                    {/* <p style={{ marginTop: 12 }}>Пароль для шифрования файла (необязательно)</p>
                    <input
                        type="password"
                        value={exportPassword}
                        onChange={onChangePassword}
                        // placeholder="пусто — файл .diet.gz (или .diet без gzip)"
                        placeholder="пароль для шифрования файла"
                        autoComplete="off"
                    />
                    <p style={{ fontSize: 12, color: '#777' }}>
                        Если вы укажете пароль, файл будет защищен и не сможет быть открыт без этого пароля.
                        Для импорта используйте тот же пароль.
                    </p> */}
                </div>
                <DuetButtons
                    first={{
                        type: 'success',
                        content: 'Экспортировать',
                        action: () => onExport(tag, exportPassword),
                    }}
                    second={{
                        type: 'transparent',
                        content: 'Отменить',
                        action: () => onClose(),
                    }}
                    disabled={false}/>
            </Modal>
        </div>
    )
}